module.exports = __webpack_public_path__ + "img/m-banner-xzdvxwdm-de-DE.9349687d.jpg";